import React from 'react';

import Classes from './Sidebar.scss';

type TSidebarProps = {
  children: React.ReactElement;
};

function Sidebar({ children }: TSidebarProps) {
  return <div className={Classes.container}>{children}</div>;
}

export default Sidebar;
